import React, {useContext} from 'react';
import {Navigate} from "react-router-dom";
import {LoginContext} from "../contexts/LoginContext";

interface ProtectedRouteProps {
  children: React.ReactElement;
  requiresAdmin?: boolean;
}

/**
 * Composant centralisé pour protéger les routes
 * Remplace AuthHandler avec une logique simplifiée
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiresAdmin = false,
}) => {
  const {currentUser} = useContext(LoginContext);

  // Utilisateur non connecté → redirection vers login
  if (!currentUser?.isLogged()) {
    sessionStorage.setItem('loginRequired', 'true');
    return <Navigate to="/" replace />;
  }

  // Utilisateur connecté mais non admin sur une route admin → redirection vers dashboard utilisateur
  if (requiresAdmin && !currentUser?.isAdmin()) {
    return <Navigate to="/user/dashboard" replace />;
  }

  // Afficher le contenu protégé
  return children;
};
